<template>
  <div class="field">
    <div class="row flex items-center">
      <div class="flex-1 mr-2">
        <form-label>
          {{ label }}
          <icon-info-circle v-if="tooltipText" class="ml-1" :text="tooltipText" />
          <slot name="after-label"></slot>
        </form-label>
        <small v-if="helpText" class="block text-80">{{ helpText }}</small>
      </div>
      <div class="">
        <button
          v-if="expandable"
          class="btn btn-default btn-secondary"
          type="button"
          @click="toggle"
        >
          {{ buttonLabel }}
        </button>
        <slot v-else name="field"></slot>
      </div>
    </div>
    <div v-if="isOpen">
      <slot name="field"></slot>
    </div>
  </div>

</template>

<script>
  import IconInfoCircle from '@/_legacy/components/Icons/IconInfoCircle.vue';

  export default {
    components: { IconInfoCircle },

    props: {
      label: {
        type: String,
        required: true,
      },
      expandable: {
        type: Boolean,
        default: false,
      },
      expanded: {
        type: Boolean,
        default: false,
      },
      helpText: {
        type: String,
        default: null,
      },
      tooltipText: {
        type: String,
      },
    },

    data: () => ({
      isOpen: false,
    }),

    computed: {
      buttonLabel() {
        if (this.isOpen) {
          return this.$t('Remove');
        }
        return this.$t('Add');
      },
    },

    watch: {
      expanded() {
        this.isOpen = this.expanded;
      },
    },

    created() {
      this.isOpen = this.expanded;
    },

    methods: {
      toggle() {
        this.isOpen = !this.isOpen;

        if (this.isOpen) {
          this.$emit('added');
        } else {
          this.$emit('removed');
        }
      },
    },
  };

</script>
